<template>
    <div>
        <b-modal
            no-close-on-esc
            no-close-on-backdrop
            size="xl"
            hide-footer
            v-model="showModal"
            :title="$t('product.createHeader')"
            scrollable
        >
            <b-form
                name="productCreateForm"
                v-on:submit.prevent="$_onSaveProductVersion"
            >
                <div class="col-xs-8 col-md-5">
                    <x-select
                        :text="$t('product.product')"
                        id="productSelect"
                        :options="productOptions"
                        v-model="selectedProduct"
                        :simpleMode="true"
                        :showDefaultOption="true"
                        :textDefaultOption="$t('product.productSelect')"
                    >
                    </x-select>
                </div>
                <div class="col-xs-8 col-md-5">
                    <x-select
                        :text="$t('product.sourceOrganization')"
                        id="organizationSelect"
                        :options="organizationOptions"
                        v-model="selectedOrganization"
                        :simpleMode="true"
                        :showDefaultOption="true"
                        :textDefaultOption="
                            $t('product.sourceOrganizationSelect')
                        "
                    >
                    </x-select>
                </div>
                <div class="col-xs-8 col-md-5">
                    <x-input
                        :text="$t('product.version')"
                        id="version"
                        v-model="version"
                    >
                    </x-input>
                </div>
                <div class="col-xs-8 col-md-5">
                    <b-button
                        type="submit"
                        id="save_button"
                        variant="primary"
                        class="d-flex align-items-center"
                        :disabled="isBtnSaveDisabled"
                    >
                        {{ $t('btnSaveLabel') }}&nbsp;<span
                            class="fas"
                            v-bind:class="{
                                'fa-check': !isSaving,
                                'fa-sync-alt fa-spin': isSaving
                            }"
                        ></span>
                    </b-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
    import XSelect from '../../components/BaseComponents/x-select.vue';
    import XInput from '../../components/BaseComponents/x-input.vue';
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    export default {
        name: 'ProductCreation',

        mixins: [modalMixin],

        props: {
            launchModal: { type: Boolean, required: false, default: false }
        },

        components: {
            'x-select': XSelect,
            'x-input': XInput
        },

        data() {
            return {
                showModal: false,
                loading: false,
                isSaving: false,
                products: [],
                organizations: [],
                selectedProduct: null,
                selectedOrganization: null,
                version: ''
            };
        },
        computed: {
            productOptions() {
                return this.products
                    ?.slice() // optional: prevents mutating original array
                    .sort((a, b) =>
                        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
                    )
                    .map((item) => ({
                        text: `${item.name}`,
                        value: item.productId
                    }));
            },
            organizationOptions() {
                return this.organizations
                    ?.slice() // optional: prevents mutating original array
                    .sort((a, b) =>
                        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
                    )
                    .map((item) => ({
                        text: `${item.name}`,
                        value: item.id
                    }));
            },
            isBtnSaveDisabled() {
                return (
                    !this.selectedProduct ||
                    !this.selectedOrganization ||
                    !this.version ||
                    this.isSaving ||
                    this.loading
                );
            }
        },

        methods: {
            async $_showModal() {
                this.showModal = true;
                this.loading = true;

                let result = await this.$store.dispatch('useApiData', {
                    name: 'GetProducts'
                });

                this.products = result.data;

                let organizationResult = await this.$store.dispatch('useApiData', {
                    name: 'GetOrganizations'
                });
                this.organizations = organizationResult.data;
                this.loading = false;
            },

            $_hideModal() {
                this.showModal = false;
            },
            async $_onSaveProductVersion() {
                try {
                    this.isSaving = true;
                    await this.$store.dispatch('useApiData', {
                        name: 'CreateProductData',
                        data: {
                            productId: this.selectedProduct,
                            SourceOrganizationId: this.selectedOrganization,
                            version: this.version
                        }
                    });

                    const data = {
                        message: this.$t('product.createSuccess'),
                        variant: 'success',
                        autoHideDelay: 3000
                    };
                    this.showToast(data);
                    this.$emit('created');
                    await this.$_hideModal();
                } catch (error) {
                    this.showToast({
                        message: this.$t(error.data.response.data.message),
                        variant: 'danger',
                        autoHideDelay: 5000,
                        noCloseButton: true
                    });
                } finally {
                    this.isSaving = false;
                }
            }
        },

        watch: {
            launchModal() {
                this.selectedProduct = null;
                this.selectedOrganization = null;
                this.version = '';
                this.$_showModal();
            }
        }
    };
</script>
